import { status } from 'skin/event/status';

const year = (obj, ms, story, data, d, action) => {
		data.setValue('month', '')
		return status.action
};

export default year;
